<section class="hd-ix-general">
  <h3 class="hd-ix-general__title">{{ title() }}</h3>
  <markdown class="hd-ix-general__markdown" [src]="generalUrl()" />

  <section class="hd-ix-general__list">
    <h4 class="hd-ix-general__list-title">{{ listTitle() }}</h4>
    @if (listIntro()) {
      <p class="hd-ix-general__list-intro">{{ listIntro() }}</p>
    }

    <div class="hd-ix-general__search">
      <e-search-input ngDefaultControl name="ix-search" border
                      [placeholder]="searchPlaceholder()"
                      [ngModel]="searchQuery()"
                      (ngModelChange)="searchQuery.set($event ?? '')" />
      @if (matchCountText()) {
        <span class="hd-ix-general__match-count" aria-live="polite">{{ matchCountText() }}</span>
      }
    </div>

    <div class="hd-ix-general__toggles">
      <e-segmented-toggle size="sm" testId="ix-list-view"
                          [options]="viewOptions()" [value]="listView()" [groupLabel]="viewLabel()"
                          (valueChange)="setListView($event)" />
      <!-- In de poortweergave niet van toepassing: blijft staan (uitgeschakeld) zodat de layout niet verspringt. -->
      <e-segmented-toggle size="sm" testId="ix-list-order"
                          [options]="orderOptions()" [value]="listOrder()" [groupLabel]="orderLabel()"
                          [disabled]="listView() === 'gate'"
                          (valueChange)="setListOrder($event)" />
    </div>

    @if (listView() === 'quarter') {
      @for (quarter of quarters(); track quarter.key) {
        <h5 class="hd-ix-general__quarter">{{ quarter.title }}</h5>
        <div class="hd-ix-general__grid" role="table" [attr.aria-label]="quarter.title">
          <div class="hd-ix-general__row hd-ix-general__row--head" role="row">
            <span class="hd-ix-general__gate" role="columnheader">#</span>
            @for (label of angleLabels(); track $index) {
              <span class="hd-ix-general__col" role="columnheader">{{ label }}</span>
            }
          </div>
          @for (row of quarter.rows; track row.gate) {
            <div class="hd-ix-general__row" role="row">
              <span class="hd-ix-general__gate" role="cell">{{ row.gate }}</span>
              @for (cell of row.cells; track $index) {
                @if (cell) {
                  <button type="button" class="hd-ix-general__cross" role="cell" (click)="openCross(cell.cross)">
                    {{ cell.name }}
                  </button>
                } @else {
                  <span class="hd-ix-general__cross-empty" role="cell"></span>
                }
              }
            </div>
          }
        </div>
      }
    } @else if (gateRows().length > 0) {
      <div class="hd-ix-general__grid hd-ix-general__grid--by-gate" role="table" [attr.aria-label]="listTitle()">
        <div class="hd-ix-general__row hd-ix-general__row--head" role="row">
          <span class="hd-ix-general__gate" role="columnheader">#</span>
          <span class="hd-ix-general__col" role="columnheader">{{ quarterColumnLabel() }}</span>
          @for (label of angleLabels(); track $index) {
            <span class="hd-ix-general__col" role="columnheader">{{ label }}</span>
          }
        </div>
        @for (row of gateRows(); track row.gate) {
          <div class="hd-ix-general__row" role="row">
            <span class="hd-ix-general__gate" role="cell">{{ row.gate }}</span>
            <span class="hd-ix-general__quarter-cell" role="cell">{{ row.quarter }}</span>
            @for (cell of row.cells; track $index) {
              @if (cell) {
                <button type="button" class="hd-ix-general__cross" role="cell" (click)="openCross(cell.cross)">
                  {{ cell.name }}
                </button>
              } @else {
                <span class="hd-ix-general__cross-empty" role="cell"></span>
              }
            }
          </div>
        }
      </div>
    }
  </section>
</section>
